import merge from 'classnames';

import { SimpleIconProps } from '../types';

import colors from 'styles/core/colors.module.scss';

export const IconDownloadV2 = ({ className, color = colors.black }: SimpleIconProps) => (
  <svg
    className={merge(className)}
    fill="none"
    height="18"
    role="img"
    viewBox="0 0 15 18"
    width="15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.59113 7.12483L6.42476 1.2912C6.70607 1.00989 7.0876 0.851859 7.48542 0.851859C7.88325 0.851859 8.26478 1.00989 8.54608 1.2912L14.3797 7.12483C14.661 7.40613 14.8191 7.78767 14.8191 8.18549C14.8191 8.58332 14.661 8.96485 14.3797 9.24615L12.2584 11.3675L11.1977 10.3068L13.3191 8.18549L7.48542 2.35186L1.65179 8.18549L3.77311 10.3068L2.71245 11.3675L0.59113 9.24615C0.309825 8.96484 0.151791 8.58331 0.151791 8.18549C0.151791 7.78767 0.309825 7.40613 0.59113 7.12483ZM6.73925 7.65145L8.2369 7.65357L8.2369 14.3283L10.1371 12.4281L11.1977 13.4888L7.48542 17.2011L3.77311 13.4888L4.83377 12.4281L6.735 14.3294L6.73925 7.65145Z"
      fill={color}
    />
  </svg>
);
